import { render, staticRenderFns } from "./BmvFileUpload.vue?vue&type=template&id=9d672ede&scoped=true"
import script from "./BmvFileUpload.vue?vue&type=script&lang=js"
export * from "./BmvFileUpload.vue?vue&type=script&lang=js"
import style0 from "./BmvFileUpload.vue?vue&type=style&index=0&id=9d672ede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d672ede",
  null
  
)

export default component.exports